module.exports = __webpack_public_path__ + "workspace/static/img/renewalManagerOne.c7b32c4.png";